import { Input, Component, OnInit } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { HttpClient } from '@angular/common/http';
import { map } from 'rxjs/operators';

declare let jQuery: any;

@Component({
  selector: 'app-content',
  templateUrl: './content.component.html'
})
export class ContentComponent implements OnInit {
  @Input() src: any;
  @Input() type: string;
  @Input() disabled: boolean;
  @Input() replaceId: string;
  @Input() origin: string;
  @Input() width: any;
  @Input() height: any;
  @Input() bannerCenterText: string;
  @Input() bannerCenterTextColor: any;

  private httpClient: HttpClient;

  protected loading = false;
  protected html: any;
  protected domSanitizer: DomSanitizer;
  protected showContent = false;
  protected showImage = false;
  protected showBanner = false;
  protected newSrc: string;

  constructor(httpClient: HttpClient, domSanitizer: DomSanitizer) {
    this.httpClient = httpClient;
    this.domSanitizer = domSanitizer;
  }

  ngOnInit(): void {
    const hostname: string = document.location.hostname;

    let uri: string = '/wcm' + this.src;

    switch (this.type) {
      case 'img':
        this.newSrc = uri;
        this.showImage = true;
        break;

      case 'banner':
        this.newSrc = uri;
        this.showBanner = true;
        break;

      default:
        this.loading = true;
        this.getContent(uri)
          .then((result: any) => {
            this.showContent = true;

            if (result) {
              if (this.replaceId) {
                jQuery('#' + this.replaceId).parent().html(result);
              } else {
                this.html = result;
              }
            }

            this.loading = false;

            const self = this;
            setTimeout(function () {
              self.loading = false;
            }, 1000);
          });
    }
  }

  protected getContent(src: string): Promise<any> {
    return this.httpClient.get(src, {
      responseType: 'text'
    }).toPromise()
      .then((response: any) => {
        return Promise.resolve(response);
      })
      .catch((error: any) => {
        this.html = '<div class="alert alert-danger">Unable to load content.</div>';
        this.loading = false;

        const self = this;
        setTimeout(function () {
          self.loading = false;
        }, 1000);
      });
  }
}

